import * as React from "react";
import isNumber from "lodash/isNumber";
import useReportingByAICustomization from "security-app/components/Investigations/AIReport/hooks/useInvestigationReportingByAICustomization";
import { Button } from "components/bootstrap";
import { Icon, HoverForHelp } from "components/common";
import AIReportModal from "security-app/components/Investigations/AIReport/AIReportModal";
import useDisclosure from "util/hooks/useDisclosure";
import useIsInvestigationAIReportEnabled from "security-app/components/Investigations/AIReport/hooks/useIsInvestigationAIReportEnabled";
import useInvestigationReportAvailability from "security-app/components/Investigations/AIReport/hooks/useInvestigationReportAvailability";
const AIReportButton = ({
  investigation,
  small = false,
  logsCount,
  eventsCount
}) => {
  var _a;
  const [showAIReportModal, { open: openAIReportModal, close: closeAIReportModal }] = useDisclosure(false);
  const { enabled: enabledForBrand } = useReportingByAICustomization();
  const { data: availability, isLoading: loadingAvailability } = useInvestigationReportAvailability(
    useIsInvestigationAIReportEnabled()
  );
  const hasNoEvidence = isNumber(logsCount) && isNumber(eventsCount) && logsCount + eventsCount === 0;
  const isUnavailable = !loadingAvailability && !availability.available;
  if (!enabledForBrand) return null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Button,
    {
      disabled: hasNoEvidence || isUnavailable,
      bsStyle: "primary",
      onClick: openAIReportModal,
      title: "Generate AI Report",
      bsSize: small ? "sm" : void 0
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "note_add", type: "regular", size: small ? "sm" : void 0 }),
    " ",
    !small && "AI Report",
    hasNoEvidence && /* @__PURE__ */ React.createElement(HoverForHelp, { title: "Add evidence" }, "Add a log or event to this investigation to generate an AI report."),
    !hasNoEvidence && isUnavailable && /* @__PURE__ */ React.createElement(HoverForHelp, { title: "AI report unavailable" }, (_a = availability.message) != null ? _a : "AI reports are not available.")
  ), showAIReportModal && /* @__PURE__ */ React.createElement(AIReportModal, { onCancel: closeAIReportModal, investigation }));
};
export default AIReportButton;
